import { Tagger } from 'interfaces/tagger';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getTaggers = () => {
  return apiRequestHandlerPromise<Tagger[]>({
    url: 'taggers',
    method: 'GET',
  });
};
